export default __webpack_public_path__ + "static/media/amsterdam.a709fb34.jpg";